module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("A rabbit skin – once you have made a quick cut up and down the hind legs and another around the head – slips off like a glove, and can be stretched on a frame and tanned and sold for a shilling to the rabbit-oh. The beak of a parrot is only worth sixpence and they’re as hard as hell to saw off. A fox’s pelt brings four shillings. And if I was lucky enough to trap a dingo, the scalp was worth a whole pound. The rabbit-oh paid the money into Mr Toad’s moist hand, even though I was the one who trapped the rabbits and skinned them and tanned their soft little hides, and Mr Toad put the money inside his trousers and afterwards hid it somewhere.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57722966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 87
// module chunks = 0